(ns teamoesterreich.user-mode.map.map-polygon
  (:require [reagent.core :as r]
            [teamoesterreich.util.log :as log]))

;
(defn init-new-polygon [initial-path]
  (js/google.maps.Polygon. #js {;:center        #js {:lat 48.185319 :lng 16.359107}
                                :paths         initial-path
                                :strokeColor   "#FFA000"
                                :strokeOpacity 0.8
                                :strokeWeight  2
                                :fillColor     "#FFF000"
                                :fillOpacity   0.1}))

(defn pick-polygon-gmap-component [initial-path]
  (log/out "Mount gmap-polygon-picker " initial-path)
  (let [gmap (atom nil)

        options (clj->js {"center" (js/google.maps.LatLng. 48.19313274477892 16.36454216955542)
                          "zoom"   14})
        update (fn [parm]
                 (log/out "Update Gmap called (sel)" initial-path)
                 (when (count initial-path)
                   (.setPath ^js (:initial-polygon @gmap) initial-path)
                   (.setMap ^js (:initial-polygon @gmap) (:map @gmap))))]
    (r/create-class
      {:reagent-render       (fn [] [:div#map-canvas {:style {:border "2px solid white"}}])
       :component-did-mount  (fn [comp]
                               (let [canvas (.getElementById js/document "map-canvas")
                                     gm (js/google.maps.Map. canvas options)]
                                 (reset! gmap {:map gm :initial-polygon (init-new-polygon initial-path)}))
                               (update comp))
       :component-did-update (fn [params]
                               (update params))
       :display-name         "gmap-component"})))

